export const trainingVideos = [
    {
        id: 'welcome-to-claraview',
        duration: '2 min',
        title: 'Welcome to Claraview Resource Library',
        description:
            'The thinking behind Claraview and how this library helps you turn patient curiosity into a growing cosmetic practice.',
        embedUrl: 'https://www.youtube.com/embed/AiVKso5G5Eo',
    },
    {
        id: 'getting-started-dashboard',
        duration: '5 min',
        title: 'Getting Started with Claraview Dashboard',
        description:
            'A walkthrough of the Dashboard and how to use it to move patients from interest to booked cases.',
        embedUrl: 'https://www.youtube.com/embed/wjuZiDCtm34',
    },
    {
        id: 'creating-the-funnel',
        duration: '5 min',
        title: 'Creating the Funnel',
        description:
            'How to build every entry point into your practice before you start driving traffic.',
        embedUrl: 'https://www.youtube.com/embed/-JJn0MRFQNE',
    },
];

export const resourceSections = [
    {
        id: 'scripts-and-templates',
        title: 'Scripts & Templates',
        description:
            'Ready-to-use scripts and templates for patient communication',
        icon: 'FileText',
        items: [
            {
                id: 'in-office-scripts',
                title: 'In-Office Scripts',
                description:
                    'Conversation starters and talking points for discussing smile previews with patients.',
                href: 'https://docs.google.com/document/d/1CJzjvoqvuTPQNZ1b2vBN1S9fXgtbD-7byKRd2Olfxck/edit?usp=sharing',
            },
            {
                id: 'template-current-patient-outreach',
                title: 'Template for Current Patient Outreach',
                description:
                    'Email templates to introduce Claraview to your existing patients.',
                href: 'https://docs.google.com/document/d/1UAbxcbV_DrIG4d8cpcmIjjTO4qI5YVCQH8E7Q6WrjlQ/edit?usp=sharing',
            },
            {
                id: 'consultation-scripts',
                title: 'Consultation Scripts',
                description:
                    'Structured scripts for how to introduce smile simulations into your in-person or virtual consultations.',
                href: 'https://docs.google.com/document/d/1KPuB9qfBLninBy2D_ynUV5i_nFD2JMBxf2-L8akAUlg/edit?usp=sharing',
            },
        ],
    },
    {
        id: 'design-assets',
        title: 'Design Assets',
        description:
            'Social media templates, brand guidelines, and marketing materials',
        icon: 'Palette',
        items: [
            {
                id: 'social-media-templates',
                title: 'Social Media Templates',
                description:
                    'Ready-to-use social post templates for your practice to launch Claraview to your audience and to keep the momentum going. Continually updated.',
                href: 'https://drive.google.com/drive/folders/1X0zltzW3kinfVCXTaZ36MLUJ5Fex12JU?usp=sharing',
            },
            {
                id: 'brand-guidelines',
                title: 'Brand Guidelines',
                description:
                    'Official Claraview brand colors, typography, and logo usage guidelines.',
                href: 'https://www.figma.com/deck/eL7GfItfqGiMFAzQrLx61L/Claraview-Brand-Guidelines?node-id=1-474&t=MtA7cvZNGf37OVfX-1',
            },
            {
                id: 'marketing-assets',
                title: 'Marketing Assets',
                description:
                    'Promotional in-office flyers and marketing materials. Please create your own QR Code to put on flyers. Reach out to hello@claraview.ai if you need assistance.',
                href: 'https://drive.google.com/drive/folders/157chsVHwA8wf2vrVDUKsLv08GMFCQL6S?usp=sharing',
            },
        ],
    },
    {
        id: 'documentation',
        title: 'Documentation',
        description:
            'Comprehensive guides and best practices for using Claraview',
        icon: 'BookOpen',
        items: [
            {
                id: 'team-training',
                title: 'Team Training',
                description:
                    'Team training materials to onboard your team and maximize platform adoption.',
                href: 'https://drive.google.com/file/d/15vQPGTir5xfpIg2o1FM3b3SCZn_G8OeJ/view?usp=sharing',
            },
            {
                id: 'qr-code-generator',
                title: 'QR Code Generator',
                description:
                    'Generate custom QR codes for your Claraview simulation link.',
                href: 'https://bitly.com/',
            },
            {
                id: 'platform-user-guide',
                title: 'Platform User Guide',
                description:
                    'Complete documentation covering all features and functionality.',
                href: '#',
            },
            {
                id: 'activation-guide',
                title: 'Activation Guide',
                description:
                    'Step-by-step instructions for activating and integrating Claraview into your practice.',
                href: 'https://docs.google.com/document/d/1wgk_7J5nrhDdK94ezOgpfFIgBeNigXaThnHhO1dn1o8/edit?usp=sharing',
            },
        ],
    },
];